import { FormControlLabel, Switch } from "@mui/material";
import { Controller, Control, FieldValues, Path } from "react-hook-form";

interface StyledSwitchProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  control: Control<T>;
}

const StyledSwitch = <T extends FieldValues>({
  name,
  label,
  control,
}: StyledSwitchProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormControlLabel
            control={
              <Switch
                checked={field.value}
                onChange={() => field.onChange(!field.value)}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label={label}
          />
        );
      }}
    />
  );
};

export default StyledSwitch;
